export const TIMESHEET_VIEWS = {
  TIMELINE: 'Timeline',
  LIST: 'List',
  TABLE: 'Table',
  REJECTED_ENTRIES: 'Rejected',
  PENDING_ENTRIES: 'Pending',
}
